export default "__VITE_ASSET__hK$yGJGW__"